import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { motion } from 'motion/react';
import { useVideo } from '../api';

export function VideoDetailPage() {
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation();
  const { data: video, isLoading } = useVideo(id || '');

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-20">
        <p className="text-slate-500">{t('common.loading')}</p>
      </div>
    );
  }

  if (!video) {
    return (
      <div className="flex items-center justify-center py-20">
        <p className="text-slate-500">Video not found</p>
      </div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="space-y-5 px-4 sm:px-6 md:px-8"
    >
      <h1 className="text-lg sm:text-2xl font-semibold">
        {video.title || t('videos.untitled', 'Untitled')}
      </h1>

      {video.url && (
        <div className="aspect-video w-full overflow-hidden rounded-xl bg-black">
          <video src={video.url} controls className="h-full w-full" />
        </div>
      )}

      {video.description && (
        <p className="text-sm text-slate-600">{video.description}</p>
      )}
    </motion.div>
  );
}
